
import React from "react";
import { Container, Row } from "reactstrap";
// used for making the prop types of this component
import PropTypes from "prop-types";

// import rub from "../../assets/img/rub.jpg";

function Footer(props) {
  return (
    <footer className={"footer" + (props.default ? " footer-default" : "")}>
      <Container fluid={props.fluid ? true : false}>
        <Row>
          <nav className="footer-nav">
            <ul>
              {/* <li>
                <img src={rub} alt="rubrankings"/>
              </li> */}
              {/* <li>
                <a href="https://www.google.com" target="_blank">
                  Blog
                </a>
              </li>
              <li>
                <a href="https://www.google.com" target="_blank">
                  Licenses
                </a>
              </li> */}
            </ul>
          </nav>
          <div className="credits ml-auto">
            <div className="copyright">
              &copy; {1900 + new Date().getYear()}, made with{" "}
              <i className="fa fa-heart heart" /> by Legacy Massage
            </div>
          </div>
        </Row>
      </Container>
    </footer>
  );
}

Footer.propTypes = {
  default: PropTypes.bool,
  fluid: PropTypes.bool,
};

export default Footer;
